import { useQuery } from '@tanstack/react-query'
import { getSessionIdFromLocalStorage } from 'src/localStorage/sessionId/getSessionIdFromLocalStorage/getSessionIdFromLocalStorage'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import {
  PageSnapshot,
  SnapshotStatus,
} from 'src/reactQuery/useGetMonitoringPagesQuery'
import { analyticsApi } from 'src/services/analyticsApi'

export interface PageSummary {
  last_snapshot_at?: string | null
  snapshot?: PageSnapshot | null
  snapshot_status?: SnapshotStatus | null
}

interface PageSummaryResponse {
  data?: PageSummary
  success?: boolean
}

const getPageSummary = async (pageId: string): Promise<PageSummary | null> => {
  const sessionId = getSessionIdFromLocalStorage()
  if (!sessionId || !pageId) return null

  const { data } = await analyticsApi().get<PageSummaryResponse>(
    '/v1_private/ads-library/page-summary',
    { params: { page_id: pageId } }
  )
  return data?.data ?? null
}

export const useGetAdsLibraryPageSummaryQuery = (pageId: string) => {
  const sessionId = getSessionIdFromLocalStorage()

  return useQuery({
    enabled: !!sessionId && !!pageId && /^\d+$/.test(pageId),
    queryFn: () => getPageSummary(pageId),
    queryKey: [QueryKey.GET_ADS_LIBRARY_PAGE_SUMMARY, pageId],
    // Backend worker produces a snapshot within ~60s of save. Poll while
    // pending so the UI flips to "ready" without a manual refresh.
    refetchInterval: (query) =>
      query.state.data?.snapshot_status === 'pending' ? 10_000 : false,
  })
}
